import { NotificationManager } from 'react-notifications';
import axios from 'axios';
import { IQueryParams } from 'src/types';

import { IMerchantGroupData, IMerchantsGroupBody, TGetGroupNames } from './types';

const getMany = async ({ page, size, sort, ...data }: IQueryParams): Promise<IMerchantGroupData> => {
  try {
    const res = await axios.post('api/v1/integration-merchant-account-group', data, { params: { page, size, sort: 'providerName,asc' } });

    return res.data;
  } catch (error) {
    NotificationManager.error("Can't fetch merchant groups");
    return null;
  }
};

const createGroup = async (body: IMerchantsGroupBody) => {
  try {
    const res = await axios.put('api/v1/integration-merchant-account-group', body);

    return res.data;
  } catch (error) {
    NotificationManager.error("Can't create merchant group");
  }
};

const editGroupById = async (id: number, body: IMerchantsGroupBody) => {
  try {
    const res = await axios.post(`api/v1/integration-merchant-account-group/${id}`, body);

    return res.data;
  } catch (error) {
    NotificationManager.error("Can't fetch edit merchant group by id");
  }
};

const getCredentialsByIntegration = async (integrationId: number): Promise<string[]> => {
  try {
    const res = await axios.get(`api/v1/payment/integrations/${integrationId}/credentials-model`);

    return res.data;
  } catch (error) {
    NotificationManager.error("Can't fetch credentials");

    return [];
  }
};

const getGroupOptionsByProviderName = async (providerName: string): Promise<TGetGroupNames | void> => {
  try {
    const res = await axios.get(`api/v1/integration-merchant-account-group/names/${providerName}`);

    return res.data;
  } catch (error) {
    return NotificationManager.error("Can't fetch groups name filter");
  }
};

const getGroupNameOptions = async (): Promise<TGetGroupNames | void> => {
  try {
    const res = await axios.get('api/v1/integration-merchant-account-group/names');

    return res.data;
  } catch (error) {
    return NotificationManager.error("Can't fetch groups name filter");
  }
};

export const merchantGroupsApi = {
  getMany,
  createGroup,
  editGroupById,
  getCredentialsByIntegration,
  getGroupNameOptions,
  getGroupOptionsByProviderName,
};
